import { initFormDataFromConfirmation } from 'modules/registration/actions/data/initFormDataFromConfirmation';
import { registrationAnalytics } from 'modules/registration/analytics';
import { REGISTRATION_FORM } from 'modules/registration/constants';
import { confirmationStore, couponsStore, isPaymentSuccessfullyCompleted } from 'modules/registration/stores';

import { form, snackStore } from 'stores';

import { parseUrlParams } from '../../utils';
import { fireToast, t } from 'utils';

function initFormDataAfterRedirect() {
  const { raceId, distanceId, paymentStatus, registrationComplete } = parseUrlParams();

  if (distanceId && raceId) {
    // Toggle the payment completed state

    // A registration uuid in registration_complete is handled by checkStripeRedirect
    if (paymentStatus && (!registrationComplete || registrationComplete === 'true')) {
      registrationAnalytics.redirectReturned(paymentStatus, null);
    }

    if (paymentStatus === 'success' && registrationComplete === 'true') {
      registrationAnalytics.completed();
      isPaymentSuccessfullyCompleted.on();
    }

    if (paymentStatus === 'error') {
      registrationAnalytics.paymentFailed({ type: 'redirect_error' });
      fireToast(t.staticAsString('registration.payment.declined'), 'error', t.staticAsString('registration.toast.validationError'));
    } else if (paymentStatus === 'cancel') {
      registrationAnalytics.paymentCancelled();
      const snackId = snackStore.error({
        i18key: 'afterPayment.cancel',
      });
      snackStore.removeWithTimeout(snackId);
    }

    const formDataJSON = sessionStorage.getItem(`${raceId}_${distanceId}`);
    if (formDataJSON) {
      form.merge(REGISTRATION_FORM, JSON.parse(formDataJSON));
    }

    const couponDataJSON = sessionStorage.getItem(`${raceId}_${distanceId}_coupon`);
    if (couponDataJSON) {
      couponsStore.setValue(JSON.parse(couponDataJSON));
    }

    const confirmationDataJSON = sessionStorage.getItem(`${raceId}_${distanceId}_confirmation`);
    if (confirmationDataJSON) {
      const confirmationData = JSON.parse(confirmationDataJSON);
      confirmationStore.setTokenData(confirmationData.token, confirmationData.tokenData);
      initFormDataFromConfirmation();
    }
  }
}

export { initFormDataAfterRedirect };
